import PricingB from './PricingB';

export default PricingB;
